export default [
  "BlockProfileInformation",
  "BlockPersonalInformation",
  "BlockPayeeInformation",
  "BlockRegistrationInformation",
  "BlockSubscriptions",
  "BlockUserNotes",
  "BlockUserFiles",
];
